import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';
import { ExaminerFunction } from './Assessment.types';

interface UseAssessmentTableColumnsProps {
  userFunction: ExaminerFunction | null;
  isVerifier: boolean;
}

export const useAssessmentTableColumns = ({ userFunction, isVerifier }: UseAssessmentTableColumnsProps) => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = [
    {
      id: 'RGZid',
      type: 'checkbox',
      title: '',
      filterType: null,
    },
    {
      id: 'flag',
      type: 'children',
      title: t('assessments:table.flag'),
      filterType: 'filter',
      skipEnterMethod: true,
    },
    {
      id: 'examTaskGroupSolutionScoreId',
      type: 'link',
      title: t('assessments:table.examTaskGroupSolutionScoreId'),
      filterType: 'search',
      sortable: true,
    },
    ...(!isVerifier

      ? [{
        id: 'examinerName',
        type: 'text' as const,
        title: 'Egzaminator',
        filterType: 'search' as const,
        sortable: true,
      }]
      : []),
    {
      id: 'status',
      type: 'text',
      title: t('assessments:table.status'),
      filterType: 'filter',
    },
    {
      id: 'pointsSum',
      type: 'text',
      title: t('assessments:table.pointsSum'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'progress',
      type: 'text',
      title: t('assessments:table.progress'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'alerts',
      type: 'children',
      title: t('assessments:table.alerts'),
      filterType: 'filter',
    },
    ...(userFunction === ExaminerFunction.PZE || isVerifier
      ? [{
        id: 'verifier',
        type: 'children' as const,
        title: t('Weryfikator'),
        filterType: 'filter' as const,
      }]
      : []),
    {
      id: 'downloadDate',
      type: 'date',
      title: t('assessments:table.downloadDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'updateDate',
      type: 'date',
      title: t('assessments:table.updateDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'text',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return { columns };
};
